import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../../consts/api";
import { http } from "../../../services/HttpService";
import { patientConsentSchema } from "./schema";
import { cond } from "../../../utilities/fp";
import { removeNullishFromShape } from "../../../utilities/general";

export const PATIENT_CONSENTS_ENTITY_TYPES = {
  patient: "patient",
  appointment: "appointment",
  procedure: "procedure",
};

const requestPayload = yup.object({
  entityId: yup.number().required(),
  entityType: yup.string().required(),
  serviceId: yup.number().nullable(),
  withMarkedAsOnFile: yup.boolean().nullable(),
});

const responseSchema = yup.array().of(patientConsentSchema);

const composeResponse = (res) => {
  if (Array.isArray(res?.data?.data)) {
    return res.data.data;
  }
  return [];
};

const createPatientConsentsQueryKey = (...args) => [
  QUERY_KEYS.patientConsents.getByEntity,
  ...args,
];

export function usePatientConsentsQuery({ payload, options = {} } = {}) {
  return useQuery(
    createPatientConsentsQueryKey(
      payload.entityId,
      payload.entityType,
      payload.serviceId,
      payload.withMarkedAsOnFile,
    ),
    async () => {
      const req = requestPayload.validateSync(payload, {
        strict: true,
      });
      const res = await http.get(
        HTTP_ENDPOINTS.patientConsents.getByEntity(
          req.entityId,
          req.entityType,
        ),
        cond(() => {}, [
          (r) => r.serviceId || r.withMarkedAsOnFile,
          () => ({
            params: removeNullishFromShape({
              service_id: req.serviceId,
              force: req.withMarkedAsOnFile ? 1 : undefined,
            }),
          }),
        ])(req),
      );
      return responseSchema.validateSync(composeResponse(res), {
        strict: true,
      });
    },
    options,
  );
}
